// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"__9ME5W","content":"Tca3x"};